module.exports = __webpack_public_path__ + "e3c5faebb4e3d8f0d32b3e5957ab318b.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/festival.jpg
// module id = 894
// module chunks = 0